<cp-auth-page-common>

  <div class="AuthPageControlsContainer"
    (keyup.enter)="onRegisterUser()">

    <div class="AuthPageControlsHeader">
      {{ 'DESIGN_B.USER_REGISTER.TITLE' | translate }}
    </div>

    <div class="AuthPageControlsLabel">
      {{ 'DESIGN_B.USER_REGISTER.EMAIL' | translate }}
    </div>

    <div class="EmailInputContainer">
      <cp-form-input
        [form]="formGroup"
        [controlName]="EMAIL"
        [valueType]="ValueType.TEXT"
        [type]="InputTagType.INPUT">
      </cp-form-input>
    </div>

    <div class="AuthPageInfoTextContainer FontSize_Rem_0_875 LineHeight_Rem_1_125">
      {{ 'DESIGN_B.USER_REGISTER.INFO' | translate }}
    </div>

    <div class="AuthPageControlsLabel">
      {{ 'DESIGN_B.USER_REGISTER.PASSWORD' | translate }}
    </div>

    <div class="PasswordInputContainer"
      [popupOpen]="true"
      [ignoreClickOutside]="showPasswordInputErrors"
      (clickOutside)="onPasswordInputLostFocus()">
      <cp-form-input [form]="formGroup"
        [valueType]="ValueType.PASSWORD"
        [controlName]="PASSWORD">
      </cp-form-input>
    </div>

    @if (formGroup?.get(PASSWORD)?.value) {
      <div
        class="PasswordRequirementsContainer">
        <cp-password-requirements [form]="formGroup"
          [controlName]="PASSWORD"
          [showErrors]="showPasswordInputErrors">
        </cp-password-requirements>
      </div>
    }

    <hr>

      <div class="AuthPageControlsFooter">
        <cp-inline-button [size]="ButtonSize.SMALL"
          [text]="'DESIGN_B.USER_REGISTER.OTHER_ACCOUNT' | translate"
          [disabled]="inProgress"
          (buttonClick)="onGoToLoginPage()">
        </cp-inline-button>
        <cp-button [size]="ButtonSize.MEDIUM"
          [disabled]="!isValid || inProgress || invalidInvitation"
          [text]="'DESIGN_B.USER_REGISTER.REGISTER' | translate"
          [stopPropagation]="false"
          [showSpinner]="inProgress"
          (buttonClick)="onRegisterUser()">
        </cp-button>
      </div>

    </div>

    @if (showInvalidMessage) {
      <div
        class="AuthPageAlertMessageContainer">
        <cp-message-design-b-small
          [(visible)]="showInvalidMessage"
      [messageText]="
        ('DESIGN_B.USER_REGISTER.WRONG_LINK' | translate)
        + ' '
        +('DESIGN_B.USER_REGISTER.LOGIN_REDIRECT_HINT' | translate)
      ">
        </cp-message-design-b-small>
      </div>
    }

    @if (wrongUserNamePwd) {
      <div
        class="AuthPageAlertMessageContainer">
        <cp-message-design-b-small
          [(visible)]="wrongUserNamePwd"
          [messageText]="'MESSAGE_TEXTS.LOGIN.WRONG_USER_NAME_OR_PASSWORD' | translate">
        </cp-message-design-b-small>
      </div>
    }

  </cp-auth-page-common>
